import { SidebarMenuItem } from 'components/atoms';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import customTwMerge from 'utils/twMerge';
import ContactLinks from '../navigation/contact-links';
import { ReactComponent as HomeSvg } from 'assets/svg/home.svg';
import { ReactComponent as BookSvg } from 'assets/svg/book.svg';
import { ReactComponent as HospitalSvg } from 'assets/svg/hospital.svg';
import { ReactComponent as CategorySvg } from 'assets/svg/category.svg';
import { ReactComponent as DoctorSvg } from 'assets/svg/doctor.svg';
import { ReactComponent as CalendarSvg } from 'assets/svg/calendar.svg';
import { ReactComponent as SecuritySvg } from 'assets/svg/security.svg';
import { ReactComponent as HistorySvg } from 'assets/svg/history.svg';
import { ReactComponent as VaccineSvg } from 'assets/svg/vaccine.svg';
import { ReactComponent as MedicineSvg } from 'assets/svg/medicine.svg';
import { ReactComponent as ReportSvg } from 'assets/svg/report.svg';
import { ReactComponent as ScissorSvg } from 'assets/svg/scissor.svg';
import { ReactComponent as FolderSvg } from 'assets/svg/folder.svg';
import { ReactComponent as StarSvg } from 'assets/svg/star.svg';
import { ReactComponent as MedalStarSvg } from 'assets/svg/medal-star.svg';

type Props = { className?: string };

export default function SidebarNavigation({ className }: Props) {
  const { t } = useTranslation('common');

  const sidebarMenuItems = [
    {
      title: t('home-page'),
      to: '/',
      Icon: <HomeSvg className="shrink-0" />,
    },
    {
      title: t('appointments'),
      to: '/appointments',
      Icon: <CalendarSvg className="shrink-0" />,
    },
    {
      title: t('membership-programs'),
      to: '/membership-programs',
      Icon: <StarSvg className="shrink-0" />,
    },
    {
      title: t('membership-purchase'),
      to: '/membership-purchase',
      Icon: <MedalStarSvg className="shrink-0" />,
    },
    {
      title: t('departments'),
      to: '/departments',
      Icon: <CategorySvg className="shrink-0" />,
    },
    {
      title: t('doctors'),
      to: '/doctors',
      Icon: <DoctorSvg className="shrink-0" />,
    },
    {
      title: t('visits'),
      to: '/visits',
      Icon: <HistorySvg className="shrink-0" />,
    },
    {
      title: t('medicine-reminder'),
      to: '/medicines',
      Icon: <MedicineSvg className="shrink-0" />,
    },
    {
      title: t('vaccine-monitoring'),
      to: '/vaccines',
      Icon: <VaccineSvg className="shrink-0" />,
    },
    {
      title: t('hospital'),
      to: '/hospital',
      Icon: <HospitalSvg className="shrink-0" />,
    },
    {
      title: t('insurances'),
      to: '/insurances',
      Icon: <SecuritySvg className="shrink-0" />,
    },
    {
      title: t('files'),
      to: '/files',
      Icon: <FolderSvg className="shrink-0" />,
    },
    {
      title: t('reports'),
      to: '/reports',
      Icon: <ReportSvg className="shrink-0" />,
    },
    {
      title: t('health-knowledge'),
      to: '/health-knowledge',
      Icon: <BookSvg className="shrink-0" />,
    },

    // {
    //   title: t('hairdresser'),
    //   to: '/pet-hairdresser',
    //   Icon: <ScissorSvg className='shrink-0'/>
    // },
  ];

  return (
    <nav
      className={customTwMerge(
        'w-[240px] shrink-0 flex-col rounded-r-[30px] bg-neutral-0 p-5 shadow-xl',
        className
      )}
    >
      <Link to="/" className="my-2 md:my-8">
        <img src="/logo.png" alt="VetAmerikan Logo" />
      </Link>

      <div className="flex flex-1 flex-col overflow-auto text-body16 text-neutral-500">
        <div className="my-8 flex flex-col gap-4">
          {sidebarMenuItems.map((item) => (
            <SidebarMenuItem to={item.to} key={item.to} Icon={item.Icon} title={item.title} />
          ))}
        </div>

        <ContactLinks />
      </div>
    </nav>
  );
}

